"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledTitle = exports.StyledLabeledInput = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../Button"));
var _Button2 = require("../../Button/Button");
var _LabledInput = _interopRequireDefault(require("../../LabledInput"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LinkForm = /*#__PURE__*/_react["default"].memo(function (props) {
  var onClose = props.onClose,
    onSubmit = props.onSubmit,
    defaultUrl = props.defaultUrl;
  var _useState = (0, _react.useState)(defaultUrl),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    url = _useState2[0],
    setUrl = _useState2[1];
  var handleSubmit = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    event.stopPropagation();
    onSubmit({
      url: url
    });
    onClose();
  }, [url]);
  var handleChangeUrl = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.persist();
    setUrl(event.target.value);
  }, []);
  var handleOnClose = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    event.preventDefault();
    onClose();
  });
  return /*#__PURE__*/_react["default"].createElement(StyledForm, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443"), /*#__PURE__*/_react["default"].createElement(StyledFields, null, /*#__PURE__*/_react["default"].createElement(StyledLabeledInput, {
    required: true,
    label: "\u0421\u0441\u044B\u043B\u043A\u0430",
    name: "href",
    placeholder: "URL",
    onChange: handleChangeUrl,
    value: url
  })), /*#__PURE__*/_react["default"].createElement(StyledControls, null, /*#__PURE__*/_react["default"].createElement(StyledButton, {
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    type: _Button2.Types.SUBMIT
  }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C"), /*#__PURE__*/_react["default"].createElement(StyledCancelButton, {
    onClick: handleOnClose
  }, "\u041E\u0442\u043C\u0435\u043D\u0430")));
});
LinkForm.propTypes = {
  onClose: _propTypes["default"].func.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  defaultUrl: _propTypes["default"].string
};
LinkForm.defaultProps = {
  defaultUrl: ''
};
var StyledForm = _styledComponents["default"].form.withConfig({
  displayName: "LinkForm__StyledForm",
  componentId: "sc-1c9d0qg-0"
})(["display:flex;flex-direction:column;padding:10px;background:white;border-radius:6px;width:670px;"]);
var StyledTitle = exports.StyledTitle = _styledComponents["default"].p.withConfig({
  displayName: "LinkForm__StyledTitle",
  componentId: "sc-1c9d0qg-1"
})(["font-size:14px;font-weight:500;line-height:1.29;"]);
var StyledFields = _styledComponents["default"].div.withConfig({
  displayName: "LinkForm__StyledFields",
  componentId: "sc-1c9d0qg-2"
})(["margin:17px 0 20px 0;"]);
var StyledControls = _styledComponents["default"].div.withConfig({
  displayName: "LinkForm__StyledControls",
  componentId: "sc-1c9d0qg-3"
})(["display:flex;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "LinkForm__StyledButton",
  componentId: "sc-1c9d0qg-4"
})(["border-radius:4px;color:white;background-color:#007aff;font-size:14px;height:42px;line-height:24px;min-height:25px;min-width:25px;padding:0;position:relative;text-align:center;"]);
var StyledCancelButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "LinkForm__StyledCancelButton",
  componentId: "sc-1c9d0qg-5"
})(["border:none;border-radius:4px;color:#4d4d4d;background-color:transparent;font-weight:normal;font-size:14px;height:42px;line-height:24px;min-height:25px;min-width:25px;padding:0;position:relative;text-align:center;"]);
var StyledLabeledInput = exports.StyledLabeledInput = (0, _styledComponents["default"])(_LabledInput["default"]).withConfig({
  displayName: "LinkForm__StyledLabeledInput",
  componentId: "sc-1c9d0qg-6"
})(["display:flex;align-items:center;margin-bottom:10px;&:last-of-type{margin-bottom:0;}div{min-width:104px;max-width:104px;margin-right:3px;font-size:14px;color:#17181a;text-transform:initial;}"]);
var _default = exports["default"] = LinkForm;